/**
 * Download Area – gated downloads via localStorage + ?tfhr=1
 */
const STORAGE_UNLOCKED = 'terfehr_dl_unlocked';
const STORAGE_PENDING = 'terfehr_dl_pending';

function getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
}

function stripUnlockParam() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('tfhr')) {
        return;
    }
    url.searchParams.delete('tfhr');
    const next = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState({}, document.title, next);
}

function isUnlocked() {
    try {
        return localStorage.getItem(STORAGE_UNLOCKED) === '1';
    } catch (e) {
        return false;
    }
}

function setUnlocked() {
    try {
        localStorage.setItem(STORAGE_UNLOCKED, '1');
    } catch (e) {
        // ignore quota / private mode
    }
}

function getPendingSlug() {
    try {
        return localStorage.getItem(STORAGE_PENDING) || '';
    } catch (e) {
        return '';
    }
}

function setPendingSlug(slug) {
    try {
        if (slug) {
            localStorage.setItem(STORAGE_PENDING, slug);
        } else {
            localStorage.removeItem(STORAGE_PENDING);
        }
    } catch (e) {
        // ignore
    }
}

function applyUnlockedUi($root) {
    $root.addClass('is-unlocked').attr('data-unlocked', '1');
}

function fillReadyPopup($root, $card) {
    const readySrc = $root.attr('data-ready-src');
    if (!readySrc) {
        return;
    }

    const $ready = $(readySrc);
    const label = $card.attr('data-label') || '';
    const title = $card.attr('data-title') || '';
    const desc = $card.attr('data-desc') || '';
    const file = $card.attr('data-file') || '';
    const $coverClone = $card.find('.downloadArea__cover').children().clone();

    $ready.find('.downloadArea__readyLabel').text(label);
    $ready.find('.downloadArea__readyTitle').text(title);
    $ready.find('.downloadArea__readyDesc').text(desc);
    $ready.find('.downloadArea__readyCover').empty().append($coverClone);

    const $dl = $ready.find('.downloadArea__readyDownload');
    if (file) {
        $dl.attr('href', file).removeAttr('aria-disabled');
    } else {
        $dl.attr('href', '#').attr('aria-disabled', 'true');
    }
}

function openInline(src, onDone) {
    if (!src || !$(src).length) {
        return;
    }
    // Fancybox 3 (theme default via @fancyapps/fancybox)
    $.fancybox.open({
        src,
        type: 'inline',
        touch: false,
        afterShow() {
            if (typeof onDone === 'function') {
                onDone($(src));
            }
        },
    });
}

/**
 * Writes the card slug into the Gravity Forms hidden field.
 * GF Admin: Hidden Field → Appearance → CSS Class Name = "download_area_slug"
 * (optional Parameter Name for dynamic population: download_area_slug)
 */
function fillGravityFormSlug($formContainer, slug) {
    if (!$formContainer || !$formContainer.length) {
        return;
    }

    const $field = $formContainer.find('.download_area_slug input, input[name="download_area_slug"]');
    if ($field.length) {
        $field.val(slug).trigger('change');
    }
}

function openRequestForCard($root, $card) {
    const slug = $card.attr('data-slug') || '';
    setPendingSlug(slug);
    const formSrc = $root.attr('data-form-src');
    openInline(formSrc, ($container) => {
        fillGravityFormSlug($container, slug);
    });
}

export default function initDownloadArea() {
    const $root = $('#downloadArea');
    if (!$root.length) {
        return;
    }

    const fromUrl = getQueryParam('tfhr') === '1' || $root.attr('data-unlocked') === '1';
    if (fromUrl) {
        setUnlocked();
        stripUnlockParam();
    }

    const unlocked = isUnlocked() || fromUrl;
    if (unlocked) {
        applyUnlockedUi($root);
    }

    $root.on('click', '[data-download-area-request]', (e) => {
        e.preventDefault();
        if (isUnlocked()) {
            return;
        }

        const $card = $(e.currentTarget).closest('.downloadArea__card');
        openRequestForCard($root, $card);
    });

    $root.on('click', '.downloadArea__media', (e) => {
        e.preventDefault();
        const $card = $(e.currentTarget).closest('.downloadArea__card');

        if (isUnlocked()) {
            const file = $card.attr('data-file');
            if (file) {
                window.open(file, '_blank', 'noopener,noreferrer');
            }
            return;
        }

        openRequestForCard($root, $card);
    });

    $root.on('click', '[data-download-area-download]', (e) => {
        if (!isUnlocked()) {
            e.preventDefault();
            return;
        }
        const href = $(e.currentTarget).attr('href');
        if (!href || href === '#') {
            e.preventDefault();
        }
    });

    // After unlock visit: show ready popup for previously clicked card
    if (unlocked) {
        const pending = getPendingSlug();
        if (pending) {
            const $card = $root.find(`.downloadArea__card[data-slug="${pending}"]`).first();
            if ($card.length) {
                fillReadyPopup($root, $card);
                setPendingSlug('');
                // Defer so Fancybox + layout are ready
                setTimeout(() => {
                    openInline($root.attr('data-ready-src'));
                }, 400);
            } else {
                setPendingSlug('');
            }
        }
    }
}
